import { render } from "./TransactionDetail.vue?vue&type=template&id=63ec6e8a"
import script from "./TransactionDetail.vue?vue&type=script&lang=js"
export * from "./TransactionDetail.vue?vue&type=script&lang=js"
script.render = render

export default script